module.exports = __webpack_public_path__ + "ui-static/img/not-found-mountain_dark.74ec0d5c.svg";